
import React, { useState, useEffect } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    Typography,
    IconButton,
    List,
    ListItemAvatar,
    ListItemText,
    ListItemSecondaryAction,
    ListItem,
    Avatar,
    Autocomplete,
    TextField,
    Stack,
    Switch
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import axios from "axios";

const InternalNotificationsPopup = ({ open, onClose, positionId }) => {
    const [inviterReceives, setInviterReceives] = useState(true);
    const [teamMembers, setTeamMembers] = useState([]);
    const [allMembers, setAllMembers] = useState([]);

    useEffect(() => {
        if (open && positionId) {
            fetchTeamMembers(positionId);
            fetchExistingTeamMembers();

        }
    }, [open, positionId]);

    const fetchTeamMembers = async (positionId) => {
        try {
            const response = await axios.get(
                `https://api.a2ajobs.com/api/setting-team-member?position_id=${positionId}`
            );
            setAllMembers(response.data.data || []);
        } catch (error) {
            console.error("Error fetching team members:", error);
        }
    };
    const fetchExistingTeamMembers = async () => {
        try {
            const response = await axios.get(`https://api.a2ajobs.com/api/get_internal_notifications_list/${positionId}`);

            if (response.data && Array.isArray(response.data.data)) {
                setTeamMembers(response.data.data); // ✅ Corrected: Accessing `data.data`
            }
        } catch (error) {
            console.error("Error fetching team members:", error);
        }
    };
    const handleAddMember = async (event, newValue) => {
        if (newValue && !teamMembers.some((member) => member.id === newValue.id)) {
            try {
                await axios.post("https://api.a2ajobs.com/api/store_internal_notifications_list", {
                    position_id: positionId,
                    user_id: newValue.id
                });

                fetchExistingTeamMembers();
            } catch (error) {
                console.error("Error adding team member:", error);
            }
        }
    };
    const handleDeleteMember = async (id) => {
        try {
            await axios.delete(
                `https://api.a2ajobs.com/api/delete_internal_notifications_list/${positionId}/${id}`
            );
            setTeamMembers(teamMembers.filter((member) => member?.user_id !== id));
        } catch (error) {
            console.error("Error deleting team member:", error);
        }
    };

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm" PaperProps={{
            sx: { borderRadius: "16px" },
        }}>
            <Stack p={2}>
                <DialogTitle>
                    <Typography variant="h5" fontWeight="bold">
                        Internal Notifications
                    </Typography>
                    <IconButton onClick={onClose} sx={{ position: "absolute", right: 8, top: 30 }}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <Typography variant="body1" sx={{ mb: 2 }} color="textSecondary">
                        Decide who will get an email whenever a candidate finishes an interview for this position.
                    </Typography>
                    <Switch
                        checked={inviterReceives}
                        onChange={(e) => setInviterReceives(e.target.checked)}
                    />
                    <Typography variant="body2" sx={{ mt: 2, fontWeight: 600 }} color="textSecondary">
                        Add Additional Team Members
                    </Typography>
                    <Autocomplete
                        fullWidth
                        options={allMembers}
                        getOptionLabel={(option) => `${option.name} (${option.email})`}
                        onChange={handleAddMember}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                variant="outlined"
                                placeholder="Select a team member"
                            />
                        )}
                        sx={{ mt: 2 }}
                    />
                    {teamMembers.length > 0 && (
                        <>
                            <Typography variant="body2" sx={{ mt: 3, fontWeight: 600 }} color="textSecondary">
                                Selected Team Members
                            </Typography>
                            <List>
                                {teamMembers?.map((member) => (
                                    <ListItem key={member.id} divider>
                                        <ListItemAvatar>
                                            <Avatar sx={{ bgcolor: "#FFCCFF", color: "#660066" }}>
                                                {member?.name.charAt(0)}
                                            </Avatar>
                                        </ListItemAvatar>
                                        <ListItemSecondaryAction>
                                            <IconButton edge="end" onClick={() => handleDeleteMember(member?.user_id)}>
                                                <CloseIcon />
                                            </IconButton>                                </ListItemSecondaryAction>
                                        <ListItemText primary={member?.name} secondary={member?.email} />
                                    </ListItem>
                                ))}
                            </List>
                        </>
                    )}
                </DialogContent>
            </Stack>
        </Dialog>
    );
};

export default InternalNotificationsPopup;

